import React from "react";

const arrowIcon = ({ className }: { className?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_72_386)">
      <path
        d="M9.96094 19.9219C11.3216 19.9219 12.6026 19.6615 13.8037 19.1406C15.0049 18.6198 16.0645 17.9004 16.9824 16.9824C17.9004 16.0645 18.6198 15.0049 19.1406 13.8037C19.6615 12.6026 19.9219 11.3216 19.9219 9.96094C19.9219 8.60026 19.6615 7.31933 19.1406 6.11816C18.6198 4.91699 17.9004 3.85742 16.9824 2.93945C16.0645 2.02148 15.0033 1.30208 13.7988 0.78125C12.5944 0.260417 11.3119 0 9.95117 0C8.5905 0 7.30957 0.260417 6.1084 0.78125C4.90723 1.30208 3.84928 2.02148 2.93457 2.93945C2.01986 3.85742 1.30208 4.91699 0.78125 6.11816C0.260417 7.31933 0 8.60026 0 9.96094C0 11.3216 0.260417 12.6026 0.78125 13.8037C1.30208 15.0049 2.02148 16.0645 2.93945 16.9824C3.85742 17.9004 4.91699 18.6198 6.11816 19.1406C7.31933 19.6615 8.60026 19.9219 9.96094 19.9219Z"
        fill="black"
        fill-opacity="0.41"
      />
      <path
        d="M15.1367 9.94141C15.1367 10.1432 15.0391 10.3418 14.8438 10.5371L11.4551 13.9453C11.3118 14.0886 11.1328 14.1602 10.918 14.1602C10.7097 14.1602 10.5355 14.0886 10.3955 13.9453C10.2555 13.8021 10.1855 13.6263 10.1855 13.418C10.1855 13.2031 10.2636 13.0208 10.4199 12.8711L11.6699 11.6406L12.8906 10.6152L10.752 10.7031H5.52734C5.30599 10.7031 5.1237 10.6315 4.98047 10.4883C4.83724 10.345 4.76562 10.1627 4.76562 9.94141C4.76562 9.72005 4.83724 9.53776 4.98047 9.39453C5.1237 9.2513 5.30599 9.17969 5.52734 9.17969H10.752L12.8809 9.26758L11.6699 8.25195L10.4199 7.01172C10.2636 6.84896 10.1855 6.66992 10.1855 6.47461C10.1855 6.26627 10.2555 6.09212 10.3955 5.95215C10.5355 5.81217 10.7097 5.74219 10.918 5.74219C11.1393 5.74219 11.3184 5.81055 11.4551 5.94727L14.8438 9.35547C15.0391 9.55078 15.1367 9.74609 15.1367 9.94141Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_72_386">
        <rect width="19.9219" height="19.9316" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default arrowIcon;
